<template>
  <div data-testid="preview" class="preview">
    <HeadingDisplay class="preview__heading" title="Revise o investimento" />
    <HeadingDisplay
      class="preview__header"
      head="Total a ser investido"
      :title="title"
    />
    <ListDisplay
      class="preview__list-display"
      :has-divider="true"
      title="Origem"
      value="Conta digital"
    />
    <ListDisplay
      class="preview__list-display"
      :has-divider="true"
      title="Destino"
      :value="investmentDetails.portfolioName"
    />
    <ListDisplay
      class="preview__list-display"
      :has-divider="false"
      title="Previsão de aplicação"
      :value="investmentDetails.expectedInvestmentDate"
    />
    <ButtonContainer class="preview__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Confirmar investimento"
          :loading="isFetchingInvestment"
          size="large"
          @click="handleInvestment"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';

const fetchInvestment = inject('fetchInvestment', () => ({}));

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const isFetchingInvestment = inject('isFetchingInvestment') as Ref<boolean>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const title = computed(() => {
  return `R$ ${amountFormatted.value}`;
});

function handleInvestment() {
  fetchInvestment();
}
</script>

<style lang="less" scoped>
.width() {
  max-width: 592px;
  width: 100%;
}

.preview {
  .width();
  margin: 0 auto;
  padding-top: @size-spacing-x800;

  &__list-display {
    margin-bottom: @size-spacing-x500;
  }

  &__header {
    margin-top: @size-spacing-x900;
    margin-bottom: @size-spacing-x600;
  }

  &__content {
    margin-top: @size-spacing-x800;
  }

  &__management-type {
    margin-top: @size-spacing-x150;
  }

  &__expected-investment-date {
    margin-top: @size-spacing-x500;
  }

  &__button-container {
    background-color: @background-secondary;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
}
</style>
